// extracted by mini-css-extract-plugin
export default {"main":"PreviewImage_main__IzLg9"};